import PropTypes from 'prop-types';
import { Box, Skeleton } from '../../../node_modules/@mui/material/index';
import { useState } from 'react';

const StoreLogo = ({ logoUrl, maxWidth = '100%', sx }) => {
  const [loaded, setLoaded] = useState(false);

  const handleImageLoad = () => {
    setLoaded(true);
  };

  return (
    <Box
      sx={{
        ...sx,
        maxWidth: maxWidth,
        height: 50
      }}>
      {!loaded && <Skeleton variant="rectangular" width={100} height="100%" animation="wave" />}
      <img
        src={logoUrl}
        alt="logo"
        style={{
          display: loaded ? 'block' : 'none',
          height: '100%',
          border: loaded ? '1px white solid' : 'none',
          borderRadius: 3,
          padding: 1
        }}
        onLoad={handleImageLoad}
      />
    </Box>
  );
};

export default StoreLogo;

StoreLogo.propTypes = {
  logoUrl: PropTypes.object,
  sx: PropTypes.object,
  maxWidth: PropTypes.number || PropTypes.string
};
